module.exports = __webpack_public_path__ + "static/JAN-22-Amarin-Harris-Poll-Infographic-The-Gender-Gap-b00c145805de016211e29aa4e7bb94df.pdf";